import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { getCommonLisingQueries } from "../../graphql/customQueries";
import { API, graphqlOperation } from "aws-amplify";
import { setInitialData } from "./UserPreference";

export const fetchCommonListingData = createAsyncThunk(
  "commonListingQueries/fetch",
  async (arg, { getState, dispatch }) => {
    try {
      const response = await API.graphql(
        graphqlOperation(getCommonLisingQueries)
      );

      const {
        ListUserPreference,
        ListAllFinancialYears,
        ListUserCompanies,
        GetCompany,
      } = response.data;
      console.log(ListUserPreference);
      const findFYID = ListUserPreference?.find(
        (fy) => fy?.AttributeTypeCD === "SelectedFinYear"
      );
      const currentFY = ListAllFinancialYears.find(
        (obj) => obj.FinancialYearID === findFYID?.AttributeValue
      );
      // dispatch(
      //   setInitialData({ currentFY, ListUserPreference, ListAllFinancialYears })
      // );
    } catch (error) {
      console.error("Error fetching user preference:", error);
      throw error;
    }
  }
);

const INITIAL_STATE = {
  render: false,
};

const initialRenderSlice = createSlice({
  name: "gstStatus",
  initialState: INITIAL_STATE,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommonListingData.fulfilled, (state, action) => { })
      .addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});

export const { } = initialRenderSlice.actions;
export default initialRenderSlice.reducer;
